import cn from 'classnames'

import { translatePaymentMethodName } from 'mmfintech-commons'

import MethodImage from './MethodImage'

import checkedIcon from '../../../assets/icons/checked.svg'

import './methodButton.scss'

type MethodButtonProps = {
  name: string
  selected: boolean
  setSelected: (name: string) => void
}

const MethodButton = ({ name, selected, setSelected }: MethodButtonProps) => (
  <div
    className={cn('method-button-wrapper', { selected })}
    onClick={() => setSelected(name)}
    data-test='button-payment-method'
  >
    <MethodImage method={name} className={cn({ selected })}>
      {selected && (
        <span className='checked-icon'>
          <img src={checkedIcon} alt='' />
        </span>
      )}
    </MethodImage>
    {translatePaymentMethodName(name)}
  </div>
)

export default MethodButton
